export const ANIMATION_DURATION = 600;



// WEBPACK FOOTER //
// ./src/modules/general-info/question-form-constants.js